import { TradingPlansTable } from '../../components/tables/Tables';
import { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../components/spinner/Spinner';
import NothingToSeeHere from '../../components/nothing-to-see-here/NothingToSeeHere';
import { config } from '../../Constants';
import { FaPlus, FaChartLine, FaBolt } from 'react-icons/fa';
import { useDisclosure } from '@mantine/hooks';
import { AddTradingPlanModal } from '../../components/modals/Modals';

const TradingPlans = () => {
  const [allData, setAllData] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const [loading, setLoading] = useState(true);
  const [opened, { open, close }] = useDisclosure(false);
  const baseURL = config.baseURL;

  // Filter data based on active tab
  const filteredData = allData.filter((plan) => {
    if (activeTab === 'all') return true;
    return plan.planType === activeTab;
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/trading-plans`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLoading(false);
        setAllData(data);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content trading-plans-page'>
      <div className='title-btn'>
        <h1 className='title'>Investment Plans</h1>
        <button className='primary' onClick={open}>
          <FaPlus /> Add Plan
        </button>
      </div>

      {/* Plan Type Tabs */}
      <div className='plan-type-tabs'>
        <button
          className={activeTab === 'all' ? 'active' : ''}
          onClick={() => setActiveTab('all')}
        >
          All Plans ({allData.length})
        </button>
        <button
          className={activeTab === 'trading' ? 'active' : ''}
          onClick={() => setActiveTab('trading')}
        >
          <FaChartLine /> Trading (
          {allData.filter((p) => p.planType === 'trading').length})
        </button>
        <button
          className={activeTab === 'mining' ? 'active' : ''}
          onClick={() => setActiveTab('mining')}
        >
          <FaBolt /> Mining (
          {allData.filter((p) => p.planType === 'mining').length})
        </button>
      </div>

      {loading ? (
        <PageSpinner />
      ) : !loading && filteredData.length > 0 ? (
        <TradingPlansTable data={filteredData} />
      ) : (
        <NothingToSeeHere />
      )}
      <AddTradingPlanModal close={close} opened={opened} />
    </main>
  );
};

export default TradingPlans;
